/**
 * @module app.demo
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/essette-api';
import { Toaster } from 'app/shared/lib/toaster';

@autoinject()
export class RuleFormExample extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////
    protected textValue: string = '';

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(
        private readonly toaster: Toaster,
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////

    ////****************** IForm ****************************************************////
    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    public async submit(): Promise<boolean> {
        const isSuccess = await this.saveForm();
        return isSuccess;
    }

    public reset(): void {
        this.textValue = '';
    }

    ////****************** Service Calls ********************************************////

    @apiCall
    protected async saveForm(): Promise<boolean> {

        let isSuccessful = false;
        try {
            this.state.beginSave();
            isSuccessful = true;

            return isSuccessful;
        }
        catch(error) {
            throw error;
        }
        finally {
            this.toaster.standard.saved('core:assessment.$', isSuccessful);
            this.state.endSave();
        }
    }
}
